module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAoCAYAAADkDTpVAAABLUlEQVRYR7WXQQrCMBBF/194CL2LghvBC7kTdCPqcRQFD+BpBI/gSKQtUdMkk0y7bMN7nU5nJiEGvmjFF5EpgBUAAXAgeXdsE4GIzAHsAIyaF36QXJoIAnDHfZJcVAt64C8Aa5K3KkEEviV5aXNblINceFEEGrhaoIWrBCXwbEEpPEtQA08KauFRQQS+IXnN7WHBOrCCByOwhP8JrOFfgiHgnaAZFkevn7tnriuqEhpK/CfJInICMPEWmMD9CM4AxkMKZm6OBj7RV2/P/ff9dV0dWFRtbw7aB0NI/irZWqJtFeqc9M5kq0iiQ99CktxV1EqSgqbSf7eGbStJ5iRLUCPJFpRKVIISiVqglRQJNJJiQUJSv31PNEibA0hEYneE8iTtIdDd2pseAmOT7g0D9N8pocrctwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_carousel_left_white.png
// module id = KV+w
// module chunks = 1